module.exports = __webpack_public_path__ + "static/bg-train@2x-1937c624f981946cb16e794841d04567.png";